import {BaseView} from "../core/view"
import {Modal, ModalTypes} from "../modal/modal"
import firebase from "firebase/app"
import "firebase/auth"
import Cookies from 'js-cookie';
import {UrlUtil} from "../utils/url-util"
import constants from "../utils/constants";

let selector = ".js-deal"

export class DealView extends BaseView{
    get el(){
        return selector
    }

    set el(elem){
        selector = elem
    }

    get events(){
        return {
            "click": "viewDeal"
        }
    }

    constructor(){
        super()
    }

    async viewDeal(e){
        let current = e.currentTarget

        if (await !firebase.auth().currentUser){
            e.preventDefault();

            let modalType = Cookies.get(constants.COOKIE_IS_REGISTERED) === "true" ? 
                ModalTypes.LOGIN : ModalTypes.SIGNUP;

            new Modal().show({
                type: modalType,
                url: UrlUtil.addParameter(current.href, "isDeals")
            })
        }
    }
}